import React from 'react';
import orgConfig from 'org/configs/org.config';

import './InstoreRebate.scss';

const { instoreLabel } = orgConfig;

function InstoreRebate({ offer, prefix = 'Earn' }) {
  const { displayRate, currency } = offer;

  return (
    <p className="mn_instoreRebate">
      {prefix} {displayRate} {currency} <span className="mn_suffix">{instoreLabel}</span>
    </p>
  );
}

export default InstoreRebate;
